import useCallApi from '../../utilities/axios'

export type DeletedProjectRequest = {
    keywordSearch?: string
    userID: number | null
}

export type DeletedProject = {
    projectId: number
    projectNumber: string
    projectName: Translation
    projectType: Translation
    remarkDeleted: string
    deletedDate: string
    name: Translation
    title: Translation
    titleID: number
    academicPosition: Translation
    considerTypeName: Translation
    considerTypeId: number
}

type Translation = {
    th: string
    en: string
}

export const useSearchDeletedProject = () => {
    const callApi = useCallApi()

    const searchDeletedProject = async (values: DeletedProjectRequest) => {
        const { data } = await callApi.axiosPost({
            url: `${process.env.REACT_APP_CU_IRB_API_URL}/project/list-deleted-beyond-deadline`,
            params: { ...values },
        })

        return data
    }

    return {
        searchDeletedProject,
    }
}
